import { render } from "./SearchText.vue?vue&type=template&id=5934af0c&scoped=true"
import script from "./SearchText.vue?vue&type=script&lang=js"
export * from "./SearchText.vue?vue&type=script&lang=js"

import "./SearchText.vue?vue&type=style&index=0&id=5934af0c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5934af0c"]])

export default __exports__